'use client'

export { default } from '@/components/errors/route-error'
